__turbopack_context__.v({
  "closeButton": "LoginModal-module__bikqZa__closeButton",
  "loginButton": "LoginModal-module__bikqZa__loginButton",
  "modalBackdrop": "LoginModal-module__bikqZa__modalBackdrop",
  "modalContent": "LoginModal-module__bikqZa__modalContent",
});
